/**
 * Download Form Popup Component
 * Opens popup when URL hash is #download-form
 * Closes on overlay click, close button click, or Escape key
 */

function fnDownloadFormPopup() {
	const popup = document.querySelector('.download-form-popup');
	if (!popup) return;

	const overlay = popup.querySelector('.popup-overlay');
	const closeButton = popup.querySelector('.close-button');

	function openPopup() {
		popup.classList.add('active');
		document.body.style.overflow = 'hidden';
	}

	function closePopup() {
		popup.classList.remove('active');
		document.body.style.overflow = '';
		
		if (window.location.hash === '#download-form') {
			history.pushState('', document.title, window.location.pathname + window.location.search);
		}
	}

	function checkHash() {
		if (window.location.hash === '#download-form') {
			openPopup();
		}
	}

	if (closeButton) {
		closeButton.addEventListener('click', closePopup);
	}

	if (overlay) {
		overlay.addEventListener('click', closePopup);
	}

	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && popup.classList.contains('active')) {
			closePopup();
		}
	});

	document.addEventListener('click', function(e) {
		const link = e.target.closest('a[href*="#download-form"]');
		if (link) {
			e.preventDefault();
			openPopup();
		}
	});

	checkHash();

	window.addEventListener('hashchange', checkHash);
}
